module.exports = __webpack_public_path__ + "img/15-1_03.90d9d196.jpg";